import React from 'react'

export default function Colors() {
  return (
    <>
      <h1>Colors</h1>
      <p>There are seven preset colors: dark, light, blue, green, red, grey and dark grey </p>
      <p> you can set the color of an element by using the .c-colorname class. For Example  <span className='tag-dark bold'>.c-dark</span></p>
    
      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="c-dark"&gt;c-dark&lt;/p&gt;<br/>
            &lt;p class="c-light"&gt;c-light&lt;/p&gt;<br/>
            &lt;p class="c-grey"&gt;c-grey&lt;/p&gt;<br/>
            &lt;p class="c-dgrey"&gt;c-dgrey&lt;/p&gt;<br/>
            &lt;p class="c-blue"&gt;c-blue&lt;/p&gt;<br/>
            &lt;p class="c-green"&gt;c-green&lt;/p&gt;<br/>
            &lt;p class="c-red"&gt;c-red&lt;/p&gt;<br/>
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve'>
        <p className="c-dark">c-dark</p>
        <p className="c-light">c-light</p>
        <p className="c-grey">c-grey</p>
        <p className="c-dgrey">c-dgrey</p>
        <p className="c-blue">c-blue</p>
        <p className="c-green">c-green</p>
        <p className="c-red">c-red</p>
      </div>

      <h1>Background Colors</h1>
      <p>There are seven preset background colors, same as for colors: dark, light, blue, green, red, grey and dark grey </p>
      <p> you can set the color of an element by using the .bc-colorname class. For Example  <span className='tag-dark bold'>.bc-dark</span></p>
    
      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
            &lt;p class="bc-dark c-light"&gt;bc-dark&lt;/p&gt;<br/>
            &lt;p class="bc-light"&gt;bc-light&lt;/p&gt;<br/>
            &lt;p class="bc-grey"&gt;bc-grey&lt;/p&gt;<br/>
            &lt;p class="bc-dgrey c-light"&gt;bc-dgrey&lt;/p&gt;<br/>
            &lt;p class="bc-blue c-light"&gt;bc-blue&lt;/p&gt;<br/>
            &lt;p class="bc-green c-light"&gt;bc-green&lt;/p&gt;<br/>
            &lt;p class="bc-red c-ligh"&gt;bc-red&lt;/p&gt;<br/>
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve'>
        <p className="bc-dark c-light">c-dark</p>
        <p className="bc-light">c-light</p>
        <p className="bc-grey">c-grey</p>
        <p className="bc-dgrey c-light">c-dgrey</p>
        <p className="bc-blue c-light">c-blue</p>
        <p className="bc-green c-light">c-green</p>
        <p className="bc-red c-light">c-red</p>
      </div>
    </>
  )
}
